import SavingsIcon from "@/assets/images/landing_page/ic-savings.svg";
import DepositIcon from "@/assets/images/landing_page/ic-deposit.svg";
import FinancingIcon from "@/assets/images/landing_page/ic-financing.svg";

export const efundingServices = [
  {
    id: 1,
    label: "Tabungan Syariah",
    description:
      "Wujudkan impian finansial Anda dengan Tabungan Syariah Dikelola sesuai prinsip syariah, aman, dan penuh keberkahan Karena menabung tak hanya soal masa depan, tapi juga nilai yang Anda pegang.",
    icon: SavingsIcon,
  },
  {
    id: 2,
    label: "Deposito Syariah",
    description:
      "Ingin keuntungan stabil tanpa RIBA? Deposito Syariah adalah solusi cerdas untuk masa depan Anda, Tidak hanya aman, tapi juga membawa nilai keberkahan dalam setiap rupiah Anda.",
    icon: DepositIcon,
  },
  {
    id: 3,
    label: "Pembiayaan Syariah",
    description:
      "Mau punya kendaraan, rumah, atau modal usaha tanpa rasa was-was? Pembiayaan Syariah: solusi halal, adil, dan penuh berkah. Bersama Efunding, wujudkan cita-cita tanpa mengorbankan nilai.",
    icon: FinancingIcon,
  },
];



// WEBPACK FOOTER //
// ./src/utils/efunding_services.js